// libraries
import React from 'react'

// components
import { OfficeType } from '/react4xp/components/Office/type'
import IconWrapper from '/react4xp/components/Icon'
import { ArrowUpRight } from '/react4xp/components/Svg/Others/Icons'

export default function Office(props: OfficeType) {
   const { img, title, address, mapsInfo, infoSet } = props

   return (
      <div className="office">
         <figure className='office__image'>
            <picture>
               {img && <img src={img?.src} alt={img?.alt} loading='lazy' />}
               
            </picture>
         </figure>

         <div className="office__title">
            {title && <h3>{title}</h3>}
         </div>

         <div className="office__separator"></div>

         <div className="office__content">
            <div className="office__address">

               <p className="address-label">
                  Visiting and postal address
               </p>

               {address && (
                  <p className="address">
                     {address}
                  </p>
               )}

               {mapsInfo && (
                  <a
                     className="maps-info"
                     target='_blank'
                     href={mapsInfo}
                  >
                     See location on Google Maps <IconWrapper className='maps-info--icon' iconColor='text-dark' iconSize='xs' IconComponent={ArrowUpRight} />
                  </a>
               )}
               
            </div>

            <div className="office__info">
               {infoSet && infoSet.map((item, index) => (
                  <div className="info-item" key={index}>
                     <p className="info-label">{item.label}</p>
                     <p className="info-content">{item.content}</p>
                  </div>
               ))}
            </div>
         </div>
      </div>
   )
}
